import VueKonva from 'vue-konva'

const VueKonvaPlugin = {
    install(Vue) {
        Vue.use(VueKonva)
    },
}

export default VueKonvaPlugin
